import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles

function PreviewSmPomen({ multiple }) {
  const modalStyle = {
    border: "7px double black",
    backgroundColor: "white",
    height: "315px",
    marginTop: "20px",
  };
  return (
    <Container style={modalStyle}>
      <p style={{ padding: "1%", fontSize: "14px" }}>Gornji tekst</p>

      <Row>
        <Col className="d-flex justify-content-around"></Col>
        <Col className="d-flex justify-content-around">
          {multiple && (
            <Carousel
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={1000}
            >
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
            </Carousel>
          )}
          {!multiple && (
            <img
              style={{
                width: "150px",
                height: "150px",
                border: "3px solid black",
              }}
              src={require("../assets/user2.png")}
              alt={`Image`}
            />
          )}
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>

      <Row style={{}}>
        <Col className="d-flex justify-content-around"></Col>
        <Col
          style={{ fontWeight: "bold", letterSpacing: "1.2px" }}
          className="d-flex justify-content-around"
        >
          Ime Prezime
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row>
        <p style={{ padding: "1%", fontSize: "14px", textAlign: "center" }}>
          Glavni tekst glavni tekst
        </p>
      </Row>

      <Row>
        <b>
          <p style={{ float: "right" }}>Od koga</p>
        </b>
      </Row>
    </Container>
  );
}

export default PreviewSmPomen;
